<template>
  <div class="investor-franchise-form">
    <!-- <EmarsysForm
      :formData="formData"  
      :content="formHeading" 
    /> -->
    <form class="contact" @submit.prevent="submit()">
      <h3 class="text-center pb-3">WANT MORE INFORMATION?</h3>
      <div class="w-full bg-white px-4 py-8 sm:px-8 flex flex-wrap">
        <div v-for="(field, f) in formData" :key="f" :class="`${field.width === 'full' ? 'w-full px-2 my-1' : 'w-full sm:w-1/2 px-2 my-1'} ${errors.indexOf(field.name) > -1 ? 'error' : ''}`">
          <template v-if="field.type === 'heading'">
            <h2 v-html="field.label" />
          </template>
          <template v-else-if="field.type === 'subheading'">
            <h5 v-html="field.label" />
          </template>
          <template v-else-if="field.type === 'label'">
            <label class="mb-1" v-html="field.label" />
          </template>
          <template v-else-if="field.type == 'textarea'">
            <label class="mb-2" :for="field.name" v-html="field.label" />
            <textarea :id="field.name" :name="field.name" :placeholder="field.placeholder" @keyup="getCharsRemaining(field.name)" v-model="model[field.name]" maxlength="256" />
            <span class="float-right">{{field.charsRemaining}} Characters Remaining</span>
          </template>
          <template v-else-if="field.type == 'select' && field.name == 'targetRegion'">
            <CountriesSelect :field="field" :model="model" :handleUpdate="updateSelect" />
          </template>
          <template v-else-if="field.type === 'checkbox'">
            <div class="flex">
              <input type="checkbox" :id="field.name" :name="field.name" v-model="model[field.name]" />
              <label :for="field.name" v-html="field.label" />
            </div>
          </template>
          <template v-else-if="field.type === 'inputquantity'">
            <label class="mb-2" :for="field.name" v-html="field.label" />
            <div class="w-full flex flex-wrap">
              <div v-for="(val, v) in model[field.name]" :key="v" class="inputquantity w-full sm:w-1/2 my-1">
                <input type="text" :id="`franchise-name-${v}`" :name="`franchise-name-${v}`" placeholder="Franchise Name" v-model="model[field.name][v].name" />
                <input type="text" :id="`franchise-units-${v}`" :name="`franchise-units-${v}`" placeholder="QTY" v-model="model[field.name][v].units" />
              </div>
              <div class="buttons w-full flex flex-wrap justify-between">
                <button type="button" class="purple" @click="addFranchise(field.name)">Add Franchise</button>
                <button type="button" class="pink" @click="removeFranchise(field.name)">Remove Franchise</button>
              </div>
            </div>
            <label v-if="errors.indexOf(field.name) && model[field.name].length" class="erorr">Please make sure all fields are filled.</label>
          </template>
          <template v-else>
            <input :type="field.type" :id="field.name" :name="field.name" :placeholder="field.label" v-model="model[field.name]" />
          </template>
        </div>
        <div v-if="sending">
          <Loader color="purple" />
        </div>
        <div v-else-if="complete && !error" class="w-full mt-4text-center">
          <div>Thank You!<br/>A member of our team will be in touch with you shortly.</div>
        </div>
        <div v-else class="flex flex-wrap items-center">
          <button type="submit" class="pulse purple">Submit</button>
          <div v-if="error" class="mt-4 lg:mt-10 lg:ml-4">
            {{ error }}
            <!-- <ErrorBasic /> -->
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import EmarsysForm from '~/components/common/EmarsysForm'
import CountriesSelect from '~/components/forms/CountriesSelect'
import ErrorBasic from '~/components/common/ErrorBasic'
import Loader from '../common/Loader'
const formData = require('~/assets/config/investorFranchiseForm.json')
const countries = require('~/assets/src/countries.json')
import { detect } from 'detect-browser'



export default {
  name: 'InvestorFranchiseForm',
  components: {
     EmarsysForm,
     CountriesSelect,
     ErrorBasic,
     Loader
  },
  data() {
    let fields = []
    let model = {}

    formData.map(f => {
      if (f.type !== 'text' && f.type !== 'tel' && f.type !== 'email') {
        f.name = f.name.replace(/[ \/]/g, "_")
      }
      if(f.name == 'targetRegion') {
        let options = []
        Object.keys(countries).map(c => {
          options.push(countries[c])
        })
        f.options = options
      }
      if (f.type === 'textarea') {
        f.charsRemaining = 256
      }
      if (f.type !== 'heading' && f.type !== 'subheading' && f.type !== 'label') {
        fields.push(f)
        if (f.type === 'inputquantity') {
          model[f.name.replace(/[ \/]/g, "_")] = []
        } else if (f.type !== 'text' || f.type !== 'tel' || f.type !== 'email') {
          model[f.name.replace(/[ \/]/g, "_")] = null
        } else {
          model[f.name] = null
        }
      }
    })
    return {
      model,
      formHeading: {
        heading: 'WANT MORE INFORMATION?',
      },
      formData,
      errors: [],
      sending: false,
      complete: false,
      error: null
    }
  },
  computed: {
    isMobile() {
      const browser = detect()
      if(browser) {
        switch(browser.os) {
          case 'iOS':
          case 'Android OS':
            return true
            break
          default:
            return false
        }
      } else {
        return false
      }
    },
  },
  methods: {
    async submit() {
      let errors = []
      let data = {
        source: 'Investor Franchise'
      }

      this.formData.map(f => {
        if (f.type !== 'heading' || f.type !== 'subheading' || f.type !== 'label') {
          if(!this.validate(f)) {
            errors.push(f.name)
          }
        }

        switch(f.type) {
          case 'tel':
            data[f.name] = this.model[f.name].replace(/[- )(]/g,'')
          case 'heading':
            break
          case 'subheading':
            break
          case 'label':
            break
          case 'checkbox': 
            data[f.name] = this.model[f.name] ? true : false
            break
          default:
            data[f.name] = this.model[f.name]
            break
        }
      })

      if (errors && errors.length) {
        this.errors = errors
      } else {
        this.sending = true
        this.error = null
        let response = null

        try {
          response = await this.$axios.post(`${this.$api.url()}/franchise`, {
            contact: {
              name: `${data.firstName} ${data.lastName}`,
              company: data.companyName,
              email: data.emailAddress,
              phone: data.phoneNumber,
              fax: data.faxNumber,
              address: '',
            },
            targetRegion: data.targetRegion,
            hospitalityExperience: {
                entertainment: data.entertainment,
                nightclub: data.nightclub,
                bar: data.bar,
                multiUnit: data.multiUnit,
                restaurant: data.restaurant,
                retail: data.retail,
                liveMusic: data.liveMusic,
                description: data.hospitalityExperience,
            },
            supplyChain: {
                retailSector: data.retailSector,
                import: data.import,
                foodAndBeverage: data.foodAndBeverage,
                vendors: data.vendors,
                franchise: data.ownedFranchise,
                targetFranchise: data.ownedFranchiseTarget,
                franchises: data.ownedFranchiseNames,
            },
            management: {
                overallExperience: data.overallExperience,
                foreignExperience: data.foreignExperience,
            },
            sales: {
                marketingAgencyExperience: data.marketingAgencyExperience,
                marketingAgencyNames: data.marketingAgencyNames,
            },
            domesticMarket: {
                experienceAndConnections: data.experienceAndConnections,
            },
            reasons: {
                experiencesOrVisits: data.experiencesOrVisits,
                backgroundCheck: data.backgroundCheck,
            }
          })
        } catch(err) {
          console.error(err)
          this.error = err.response.data.message
        }

        this.sending = false
        this.complete = true
      }
    },
    validate(f) {
      if (f.required) {
        switch(f.type) {
          case 'tel':
            return this.model[f.name] && this.model[f.name].match(/^[\(]?[1-9]{1}[0-9]{2}[\)\s\-\.]*[1-9]{1}[0-9]{2}[\s\-\.]?[0-9]{4}/)
            break
          case 'email':
            return this.model[f.name] && this.model[f.name].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
            break
          case 'text':
            return this.model[f.name] && this.model[f.name].match(/^[A-Za-z0-9]+/)
            break
          case 'inputquantity':
            if (!this.model[f.name] || (this.model[f.name] && !this.model[f.name].length)) {
              return false
            } else {
              let valid = false
              this.model[f.name].map(i => {
                valid = i.name && i.units ? true : false
              })

              return valid
            }
            return false
            break
          default:
            return this.model[f.name] ? true : false
        }
      }

      return true
    },
    getCharsRemaining(field) {
      let fieldData = this.formData.find(f => f.name === field)
      if(this.model[field]) {
        fieldData.charsRemaining = 256 - this.model[field].length
      }
    },
    updateSelect(name, value) {
      this.model[name] = value
    },
    addFranchise(name) {
      this.model[name].push({
        name: '',
        units: ''
      })
    },
    removeFranchise(name) {
      this.model[name].pop()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/_variables.scss';

.investor-franchise-form {
  form.contact {
    > div {
      > div {
        h2 {
          font-size: 24px;
          line-height: 100%;
          font-weight: 700;
          margin: 15px 0;
          color: $purple;
          text-transform: capitalize;
        }

        h5 {
          font-size: 20px;
          line-height: 100%;
          font-weight: 700;
          margin: 10px 0;
          color: $purple;
          text-transform: capitalize;
        }

        .inputquantity {
          display: flex;
          align-items: center;
          gap: 10px;
          
          @media (min-width: $sm) {
            padding-right: 15px;

            &:nth-of-type(2n) {
              padding-left: 15px;
              padding-right: unset;
            }
          }

          input {
            &:first-of-type {
              flex: 1;
            }

            &:last-of-type {
              width: 40px;
            }
          }
        }

        .buttons {
          button {
            width: 100%;
            margin-top: 15px;

            @media (min-width: $sm) {
              width: 47.5%;
            }
          }
        }

        &:first-of-type {
          h2 {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>